module.exports = __webpack_public_path__ + "501fea6f0fad50796cd6c0760528eabd.pdf";